var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VWrapper',{attrs:{"title":"auditing.index","sub-title":"common.overview"}},[_c('VCard',{staticClass:"pa-4"},[_c('AuditingTable',{attrs:{"items":_vm.items,"total":_vm.total,"venues":_vm.venuesFiltered},on:{"page":function($event){return _vm.getItems({ page: $event.page })},"filter":_vm.onFilter}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }